module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "greenSendIcon3.ece9e5ea.png";